import React from 'react'
import { useTranslation } from 'react-i18next';
const SuccesPopup = (props) => {
    const { t , i18n } = useTranslation();
    const isRTL = i18n.language === 'ar';
    return (
        <div className={`${isRTL ? 'rtl font-almarai' : 'ltr font-inter'}`}>
            <div onClick={props.close} className='fixed inset-0 z-[1000000] bg-black opacity-50'></div>
            <div className={`fixed z-[1000001] inset-[50%] -translate-x-[50%] drop-shadow-md -translate-y-[50%] w-[250px] md:w-[444px] h-fit rounded-[24px] p-[16px] md:p-[22px]  bg-white  flex flex-col gap-2 md:gap-3 justify-center items-center`}>
                    {props.icon}
                    <p className={` flex justify-center text-center ${props.erorr ? 'text-primary' : 'text-primary02'} text-[12px] md:text-[20px]`}>{props.don}</p>
                <button onClick={props.close} className={`
                    uppercase text-white tracking-widest ${props.erorr ? 'bg-primary' : 'bg-primary02'} px-4 py-2 md:py-3  flex items-center 
                    justify-center rounded-lg w-full text-[12px] md:text-[20px]`}>{t('popup.button')}</button>
            </div>
        </div>
    )
}

export default SuccesPopup